import React, { useEffect, useState } from "react";
import IconBeneficiario from "../Resources/svg/Icons/IconBeneficiario";
import IconTableDown from "../Resources/svg/Icons/IconTableDown";
import {
  genderList,
  sideActionsRV,
} from "../Utils/constants";
import { getTitleCase } from "../Utils/simulaciones/simulaciones";
import { getDocumentLabel, relationshipFormatter, transformDate } from "../Utils/utils";

export const CardBeneficiary = ({
  beneficiary,
  cardId,
  actionSideQuote,
  setSelectedBeneficiary,
  state,
}: any) => {
  const [collapse, setCollapse] = useState(false);

  const {
    primerNombre,
    segundoNombre,
    apellidoPaterno,
    apellidoMaterno,
    fechaNacimiento,
    parentesco,
    genero,
    condicionInvalidez,
  } = beneficiary;

  const handleCardStateTable = () => {
    setCollapse((c) => !c);
  };

  useEffect(() => {
    if (cardId !== 0) return;
    setCollapse(true);
  }, [cardId]);

  const genderListRV: any = genderList;

  return (
    <div className="card-verify__beneficiary" style={{ position: "relative" }}>
      <div className="clientForm__beneficiary-box-icon">
        <IconBeneficiario />
        <div className="clientForm__beneficiary">Beneficiario {cardId + 1}</div>
      </div>
      <div className={`card-table__icon`} onClick={handleCardStateTable}>
        <IconTableDown className={`${collapse ? "up" : "down"}`} />
      </div>

      {collapse && (
        <>
          <div className="card-verify__body">
            <div className="card-verify__quote">Nombres:</div>
            <div className="card-verify__data">
              {getTitleCase(
                `${primerNombre} ${segundoNombre ? segundoNombre : ""}`
              )}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Apellidos:</div>
            <div className="card-verify__data">
              {getTitleCase(`${apellidoPaterno} ${apellidoMaterno}`)}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Parentesco:</div>
            <div className="card-verify__data">
              {relationshipFormatter(parentesco, genero)}
            </div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Salud:</div>
            <div className="card-verify__data">{condicionInvalidez}</div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Fecha Nacimiento:</div>
            <div className="card-verify__data">{transformDate(fechaNacimiento)}</div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Género:</div>
            <div className="card-verify__data">{genderListRV[genero]}</div>
          </div>
          {beneficiary.tipoDocumento && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Tipo de Documento:</div>
                <div className="card-verify__data">
                  {getDocumentLabel(beneficiary.tipoDocumento)}
                </div>
              </div>
            </>
          )}
          {beneficiary.numeroDocumento && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Número de Documento:</div>
                <div className="card-verify__data">
                  {beneficiary.numeroDocumento}
                </div>
              </div>
            </>
          )}
          {beneficiary.telefono && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Celular:</div>
                <div className="card-verify__data">{beneficiary.telefono}</div>
              </div>
            </>
          )}
          {beneficiary.correoElectronico && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Email:</div>
                <div className="card-verify__data">
                  {beneficiary.correoElectronico}
                </div>
              </div>
            </>
          )}
          {beneficiary.ubigeo && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Departamento:</div>
                <div className="card-verify__data">
                  {beneficiary.departamento}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Provincia:</div>
                <div className="card-verify__data">{beneficiary.provincia}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Distrito:</div>
                <div className="card-verify__data">{beneficiary.distrito}</div>
              </div>
            </>
          )}
          {beneficiary.direccion && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Dirección:</div>
                <div className="card-verify__data">{beneficiary.direccion}</div>
              </div>
            </>
          )}
          {beneficiary.referencia && (
            <>
              <div className="card-verify__body">
                <div className="card-verify__quote">Referencia:</div>
                <div className="card-verify__data">
                  {beneficiary.referencia}
                </div>
              </div>
            </>
          )}
          <div className="clientForm__beneficiary-box-with-icon-button">
            {state !== "anulado" && (
              <button
                className="btn is-secondary is-small"
                onClick={() => {
                  actionSideQuote(sideActionsRV.ACTUALIZAR_BENEFICIARIO);
                  setSelectedBeneficiary({ ...beneficiary, indice: cardId });
                }}
              >
                Editar
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};
